import { Link } from 'react-router-dom'

export default function Navbar() {
  return (

    <div className='navbar fixed-top navbar-expand-md navbar-dark bg-success bg-gradient p-0'>
      <div className='container-md'>
        <button className='navbar-toggler' type='button' data-bs-toggle='collapse' data-bs-target='#navbarToggleExternalContent' aria-controls='navbarToggleExternalContent' aria-expanded='false' aria-label='Toggle navigation'>
          <span className='navbar-toggler-icon'></span>
        </button>
        <div className='collapse navbar-collapse fs-6' id='navbarToggleExternalContent'>
          <a className='navbar-brand' href='/'>NAG Logistics</a>
          <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
            <li className='nav-item'>
              <Link to='/dashboard' className='nav-link'>Dashboard</Link>
            </li>
            <li className='nav-item'>
              <Link to='/orders' className='nav-link'>Orders</Link>
            </li>
            {process.env.NODE_ENV === 'development' ? (
              <>
                <li className='nav-item'>
                  <Link to='/component' className='nav-link'>Component</Link>
                </li>
                <li className='nav-item'>
                  <Link to='/experiment' className='nav-link'>Experiment</Link>
                </li>
              </>
            ) : null
            }
          </ul>
          <div className='d-flex'>
            <Link to='/log-in' className='nav-link'>Log in</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
